import MuiAvatar, { type AvatarProps } from "@mui/material/Avatar";
import MuiAvatarGroup, { type AvatarGroupProps } from "@mui/material/AvatarGroup";

export type { AvatarProps, AvatarGroupProps };

export function Avatar(props: AvatarProps) {
  return <MuiAvatar {...props} />;
}

export function AvatarGroup(props: AvatarGroupProps) {
  return <MuiAvatarGroup {...props} />;
}
